import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

import MenuApp from './menuApp';

class MenuMobil extends Component {

    constructor(props) {
        super(props);
        this.state = { isFolded: true };
        this.changeFoldUnfold = this.changeFoldUnfold.bind(this);
        this.tancarMenu = this.tancarMenu.bind(this);
    }

    changeFoldUnfold() {
        this.setState({ isFolded: !this.state.isFolded });
    }

    tancarMenu() {
        if (!this.state.isFolded) {
            this.setState({ isFolded: true});
        }
    }

    render() {
        const { urlActual } = this.props;
        const { isFolded } = this.state;

        const estilsMenu = isFolded ? { display: 'none' } : {};
        const tipusIcona = isFolded ? 'menu-fold' : 'menu-unfold';

        return (
            <div className='menu-mobil-contenidor' onMouseLeave={this.tancarMenu}>
                <Icon
                    className='menu-mobil-icona'
                    type={tipusIcona}
                    onClick={this.changeFoldUnfold}
                />
                <MenuApp
                    urlActual={urlActual}
                    modeMenu='inline'
                    classeCssMenu='menu-mobil'
                    onClickMenuItem={this.tancarMenu}
                    estilsMenu={estilsMenu}
                />
            </div>
        );
    }
}

MenuMobil.propTypes = {
    urlActual: PropTypes.string
};

export default MenuMobil;



// WEBPACK FOOTER //
// ./src/components/capcalera/menu/menuMobil.js